import { Theme } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme, ButtonProps>(theme => ({
  container: {
    '&:hover': {
      textDecoration: 'underline',
      textDecorationColor: props =>
        props.color === 'secondary' ? theme.palette.common.gray600 : theme.palette.primary.main,
    },
    color: props => (props.color === 'secondary' ? theme.palette.common.gray600 : theme.palette.primary.main),
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
  },
}));

export default useStyles;
